// Static site content for Apex Home Pro Inc
import {
  Wrench, PaintRoller, Ruler, SquareStack, Fence, Rows3, Bath, ChefHat, Layers, Blocks, DoorOpen, TreePine,
} from "lucide-react";

export const COMPANY = {
  name: "Apex Home Pro Inc",
  tagline: "Craftsmanship you can stand on.",
  phone: "(484) 632-5956",
  phoneRaw: "+14846325956",
  email: "mike@apexhomeproinc.com",
  address: "801 Broad St, Wescosville, PA 18106",
  area: "Lehigh Valley, Pennsylvania",
  hours: "Mon–Sat · 9:00 AM – 5:00 PM",
  facebook: "https://www.facebook.com/Apexhomeproinc",
  instagram: "https://www.instagram.com/Apexhomeproinc",
  tiktok: "https://www.tiktok.com/@Apexhomeproinc",
};

export const SERVICES = [
  {
    id: "kitchens-baths",
    title: "Kitchens & Bathrooms",
    icon: ChefHat,
    blurb: "Full gut renovations to refined refreshes — cabinetry, counters, fixtures and finish.",
    image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-8",
  },
  {
    id: "bathrooms",
    title: "Tile & Bathrooms",
    icon: Bath,
    blurb: "Precision tile, waterproofing and spa-grade bathroom builds.",
    image: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    span: "lg:col-span-4",
  },
  {
    id: "additions",
    title: "Home Additions",
    icon: Blocks,
    blurb: "Add real square footage — room additions, second stories and bump-outs, permitted and finished.",
    image: "https://images.unsplash.com/photo-1584738766473-61c083514bf4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-8",
  },
  {
    id: "framing",
    title: "Framing & Structural",
    icon: Ruler,
    blurb: "Load-bearing changes and new builds framed true and to code.",
    image: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    span: "lg:col-span-4",
  },
  {
    id: "basement-finishing",
    title: "Basement Finishing",
    icon: Layers,
    blurb: "Turn an unfinished basement into living space — family rooms, suites, home offices and more.",
    image: "https://images.unsplash.com/photo-1704040686433-b1c45e9f4104?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-8",
  },
  {
    id: "decks",
    title: "Decks & Outdoor",
    icon: TreePine,
    blurb: "Custom decks, patios and outdoor living spaces built to last through PA seasons.",
    image: "https://images.unsplash.com/photo-1613544723371-23b514a78c85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-4",
  },
  {
    id: "windows-doors",
    title: "Windows & Doors",
    icon: DoorOpen,
    blurb: "Energy-efficient window and entry-door replacement that seals tight and looks sharp.",
    image: "https://images.unsplash.com/photo-1751486403820-7cf45ebec080?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-8",
  },
  {
    id: "fencing",
    title: "Fencing",
    icon: Fence,
    blurb: "Vinyl, wood and aluminum fencing for privacy, pets and curb appeal.",
    image: "https://images.unsplash.com/photo-1744701752665-6d94c9c841e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    span: "lg:col-span-4",
  },
  {
    id: "flooring",
    title: "Flooring",
    icon: Rows3,
    blurb: "Hardwood, LVP and tile flooring installed with dead-level precision.",
    image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    span: "lg:col-span-4",
  },
  {
    id: "paint",
    title: "Painting & Finish",
    icon: PaintRoller,
    blurb: "Interior and exterior painting with clean lines and durable coatings.",
    image: null,
    span: "lg:col-span-4",
  },
  {
    id: "concrete",
    title: "Concrete",
    icon: SquareStack,
    blurb: "Foundations, walkways, driveways and stamped concrete.",
    image: null,
    span: "lg:col-span-4",
  },
];

export const SERVICE_OPTIONS = [
  "Kitchen Remodel",
  "Bathroom Remodel",
  "Home Addition",
  "Framing / Structural",
  "Tile Work",
  "Decks & Outdoor",
  "Flooring",
  "Windows & Doors",
  "Fencing",
  "Painting",
  "Concrete",
  "Full Home Renovation",
  "Other / Not Sure",
];

export const BUDGET_OPTIONS = [
  "Under $5,000",
  "$5,000 – $15,000",
  "$15,000 – $40,000",
  "$40,000 – $100,000",
  "$100,000+",
  "Not sure yet",
];

export const TIMELINE_OPTIONS = [
  "As soon as possible",
  "1–3 months",
  "3–6 months",
  "6+ months",
  "Just planning",
];

export const STATS = [
  { value: "15+", label: "Years in the Valley" },
  { value: "500+", label: "Projects completed" },
  { value: "100%", label: "Licensed & insured" },
  { value: "4.9★", label: "Average rating" },
];

export const WHY = [
  { title: "Local & accountable", text: "Lehigh Valley owned and operated. We answer the phone and stand behind every job." },
  { title: "One crew, start to finish", text: "No revolving subs. The same trusted team frames, tiles and finishes your project." },
  { title: "Clear, honest pricing", text: "Detailed written estimates with no surprise line items halfway through." },
  { title: "Built to code, built to last", text: "Fully licensed and insured work that passes inspection the first time." },
];

export const GALLERY = [
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_apex-pro-rebuild/artifacts/xj1mdee1_20161020_173918_Original.webp", cat: "Concrete", alt: "Finished curved concrete walkway alongside home" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_apex-pro-rebuild/artifacts/b0dedtlv_20161020_173907_Original.webp", cat: "Concrete", alt: "New finished concrete patio by back door" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_apex-pro-rebuild/artifacts/k51sh21s_20161020_131217_Original.webp", cat: "Concrete", alt: "Concrete walkway forms and grading in progress" },
  { src: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", cat: "Kitchens", alt: "Modern kitchen remodel with island" },
  { src: "https://images.unsplash.com/photo-1521783593447-5702b9bfd267?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", cat: "Bathrooms", alt: "Renovated bathroom with freestanding tub" },
  { src: "https://images.unsplash.com/photo-1613544723412-b331bda01e87?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", cat: "Decks", alt: "Custom backyard deck with seating" },
];

export const TESTIMONIALS = [
  { name: "Michael R.", city: "Allentown, PA", text: "Apex gutted and rebuilt our kitchen in under three weeks. The crew was respectful, clean, and the finish work is flawless.", stars: 5 },
  { name: "Danielle K.", city: "Bethlehem, PA", text: "They built a beautiful composite deck for us. Fair quote, no surprises, and it looks better than we imagined.", stars: 5 },
  { name: "Tom & Lisa P.", city: "Emmaus, PA", text: "Full bathroom remodel with custom tile. Communication was excellent from estimate to final walkthrough.", stars: 5 },
  { name: "Sandra M.", city: "Macungie, PA", text: "Honest, on time, and skilled. We've already booked them for our basement finish. Highly recommend.", stars: 5 },
];
